module.exports = __webpack_public_path__ + "static/media/phone.c8b4b5a5.svg";